export default "__VITE_ASSET__0394e9b8__"